import React from 'react';
import { Typography } from '@mui/material';
import { List, ListItem, ListItemText } from '@mui/material';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { utilGet } from 'util/tableUtils';

const UnorderedList = ({
  data,
  itemPath,
  placeholder,
  secondaryItemPath,
  primaryFunc,
  secondaryFunc,
  prefix,
  suffix,
}) => {
  if (!data || data.length === 0) {
    return <Typography variant="subtitle1">{placeholder}</Typography>;
  }

  return (
    <List>
      {data.map((item, index) => (
        <ListItem
          disableGutters
          key={itemPath ? get(item, itemPath, index) : index}
          sx={{ py: 0 }}
        >
          {utilGet(item, prefix)}
          <ListItemText
            primary={utilGet(item, primaryFunc || itemPath, itemPath)}
            secondary={
              secondaryFunc || secondaryItemPath
                ? utilGet(item, secondaryFunc || secondaryItemPath, secondaryItemPath)
                : undefined
            }
          />
          {utilGet(item, suffix)}
        </ListItem>
      ))}
    </List>
  );
};
UnorderedList.propTypes = {
  data: PropTypes.array,
  itemPath: PropTypes.string,
  secondaryItemPath: PropTypes.string,
  placeholder: PropTypes.string,
  primaryFunc: PropTypes.func,
  secondaryFunc: PropTypes.func,
  prefix: PropTypes.func,
  suffix: PropTypes.func,
};
export default UnorderedList;
